module.exports = __webpack_public_path__ + "static/img/arkusz_materialow_2.3633aad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arkusz_materialow_2.png
// module id = 9xi7
// module chunks = 0